/**
 * Environment Configuration for Shared Library
 * Provides database path utilities - environment must be provided by the consuming application
 */

// Database path construction - requires environment parameter
export const getDatabasePath = (path: string, environment: 'dev' | 'prod'): string => {
  const basePath = environment === 'dev' ? 'dev' : 'prod';
  return `${basePath}/${path}`;
};

// Common database paths - requires environment parameter
export const databasePaths = {
  users: (environment: 'dev' | 'prod') => getDatabasePath('users', environment),
  challenges: (environment: 'dev' | 'prod') => getDatabasePath('challenges', environment),
  organizations: (environment: 'dev' | 'prod') => getDatabasePath('organizations', environment),
  teams: (environment: 'dev' | 'prod') => getDatabasePath('teams', environment),
  leaderboards: (environment: 'dev' | 'prod') => getDatabasePath('leaderboards', environment),
  notifications: (environment: 'dev' | 'prod') => getDatabasePath('notifications', environment),
  settings: (environment: 'dev' | 'prod') => getDatabasePath('settings', environment),
  participations: (environment: 'dev' | 'prod') => getDatabasePath('participations', environment),
  health_data: (environment: 'dev' | 'prod') => getDatabasePath('health_data', environment),
  service_accounts: (environment: 'dev' | 'prod') => getDatabasePath('service_accounts', environment),
  family_members: (environment: 'dev' | 'prod') => getDatabasePath('family_members', environment),
  user_family_status: (environment: 'dev' | 'prod') => getDatabasePath('user_family_status', environment)
};

// Challenge-specific paths - requires environment parameter
export const challengePaths = {
  global: (environment: 'dev' | 'prod') => `${databasePaths.challenges(environment)}/global_challenges`,
  personal: (environment: 'dev' | 'prod') => `${databasePaths.challenges(environment)}/personal_challenges`,
  organization: (environment: 'dev' | 'prod') => `${databasePaths.challenges(environment)}/organization_challenges`,
  team: (environment: 'dev' | 'prod') => `${databasePaths.challenges(environment)}/team_challenges`
};

// Debug logging - requires environment parameter
export const logEnvironmentInfo = (environment: 'dev' | 'prod') => {
  console.log('[SharedLib Environment]', {
    environment,
    databasePaths: {
      users: databasePaths.users(environment),
      challenges: databasePaths.challenges(environment),
      organizations: databasePaths.organizations(environment)
    },
    challengePaths: {
      global: challengePaths.global(environment),
      personal: challengePaths.personal(environment),
      organization: challengePaths.organization(environment),
      team: challengePaths.team(environment)
    }
  });
};
